import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck, Receipt, BadgeDollarSign, AlarmClock } from "lucide-react";
import { api } from "@/lib/api";
import { fecha } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const ICONOS = {
  factura_emitida: Receipt,
  pago_recibido: BadgeDollarSign,
  recordatorio_pago: AlarmClock,
  general: Bell,
};

export const Notificaciones = () => {
  const [data, setData] = useState({ no_leidas: 0, notificaciones: [] });
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const cargar = () => api.get("/notificaciones").then((r) => setData(r.data)).catch(() => {});

  useEffect(() => {
    cargar();
    const id = setInterval(cargar, 45000);
    return () => clearInterval(id);
  }, []);

  const abrir = async (n) => {
    if (!n.leida) {
      await api.post(`/notificaciones/${n.id}/leer`);
      cargar();
    }
    if (n.factura_id) {
      setOpen(false);
      navigate("/portal/finanzas");
    }
  };

  const leerTodas = async () => {
    await api.post("/notificaciones/leer-todas");
    cargar();
  };

  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o) cargar(); }}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid="notificaciones-boton">
          <Bell className="h-4 w-4" />
          {data.no_leidas > 0 && (
            <span data-testid="notificaciones-badge"
                  className="absolute -right-0.5 -top-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-accent px-1 text-[10px] font-bold text-accent-foreground">
              {data.no_leidas}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[340px] p-0" data-testid="notificaciones-panel">
        <div className="flex items-center justify-between border-b border-border px-4 py-3">
          <p className="font-display text-sm font-bold">Notificaciones</p>
          {data.no_leidas > 0 && (
            <button onClick={leerTodas} data-testid="marcar-todas-leidas"
                    className="flex items-center gap-1 text-xs text-primary hover:underline">
              <CheckCheck className="h-3 w-3" /> Marcar leídas
            </button>
          )}
        </div>
        <div className="max-h-[360px] overflow-y-auto">
          {data.notificaciones.length === 0 && (
            <p className="px-4 py-8 text-center text-sm text-muted-foreground" data-testid="notificaciones-vacias">
              No tiene notificaciones.
            </p>
          )}
          {data.notificaciones.map((n) => {
            const Icon = ICONOS[n.tipo] || Bell;
            return (
              <button key={n.id} onClick={() => abrir(n)} data-testid={`notificacion-${n.id}`}
                      className={`flex w-full gap-3 border-b border-border/60 px-4 py-3 text-left transition-colors hover:bg-muted/60 ${
                        n.leida ? "opacity-70" : "bg-primary/[0.04]"}`}>
                <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${n.leida ? "text-muted-foreground" : "text-primary"}`} />
                <span className="min-w-0">
                  <span className="block text-sm font-semibold">{n.titulo}</span>
                  <span className="mt-1 block text-xs leading-relaxed text-muted-foreground">{n.mensaje}</span>
                  <span className="mt-1 block text-[10px] uppercase tracking-widest text-muted-foreground/70">
                    {fecha(n.creado_en)}
                  </span>
                </span>
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};
